import "../chunk-D57E6H3M.mjs";

// src/utils/announce.ts
var ANNOUNCE_DELAY_MS = 100;
function createAnnouncerStore() {
  let message = "";
  let timer;
  const listeners = /* @__PURE__ */ new Set();
  const set = (next) => {
    message = next;
    for (const listener of listeners) listener();
  };
  return {
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getMessage: () => message,
    announce: (next) => {
      clearTimeout(timer);
      set("");
      if (next) timer = setTimeout(set, ANNOUNCE_DELAY_MS, next);
    },
    clear: () => {
      clearTimeout(timer);
      set("");
    }
  };
}
var appAnnouncer = createAnnouncerStore();
var subscribeAnnouncement = appAnnouncer.subscribe;
var getAnnouncement = appAnnouncer.getMessage;
var announce = appAnnouncer.announce;
export {
  ANNOUNCE_DELAY_MS,
  announce,
  createAnnouncerStore,
  getAnnouncement,
  subscribeAnnouncement
};
//# sourceMappingURL=announce.mjs.map